import { GuideAPI } from './guide';
import { GrowthLogAPI } from './stat';

export const GrowthApi =  { ...GrowthLogAPI, ...GuideAPI };